module.exports = __webpack_public_path__ + "static/media/southamerica.e85329f3.png";